import { Methods } from "@newview/infrastructure";
import { NewviewOaBaseApi } from "./NewviewOaBaseApi";

/**
 * 酒店信息
 */
export class ApplyHotelInformationApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'apply-hotel-information'
    }




}
